import stbAPIGateway from '../../../../services/stbAPIGateway';

export const postClientStudentManagementGroupingCsvToJson = async (
  { rootGetters },
  { clientSid, file }
) => {
  const axios = rootGetters['app/stbAxios'];
  const apiUrl = process.env.API_URL || '';
  const stbApi = stbAPIGateway(axios, apiUrl);
  const response = await stbApi.postClientStudentManagementGroupingCsvToJson(clientSid, file);
  return response;
};
